module.exports = __webpack_public_path__ + "img/hakurei tea party.b29b24a8.png";